import React from 'react';
import './DashboardSidebar.css';

const DashboardSidebar = ({ sections, activeSection, onSectionChange, user, onLogout, isOpen, onToggle }) => {
  return (
    <aside className={`dashboard-sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="dashboard-sidebar-header">
        <div className="dashboard-sidebar-logo">
          <h2>مراسلات</h2>
        </div>
        <button className="dashboard-sidebar-toggle" onClick={onToggle}>
          {isOpen ? '→' : '←'}
        </button>
      </div>

      <nav className="dashboard-sidebar-nav">
        {sections.map((section) => (
          <button
            key={section.id}
            className={`dashboard-nav-item ${activeSection === section.id ? 'active' : ''}`}
            onClick={() => onSectionChange(section.id)}
          >
            <span className="dashboard-nav-icon">{section.icon}</span>
            {isOpen && <span className="dashboard-nav-text">{section.name}</span>}
          </button>
        ))}
      </nav>

      <div className="dashboard-sidebar-footer">
        <div className="dashboard-user-info">
          {isOpen && (
            <>
              <div className="dashboard-user-name">{user?.username || 'Admin'}</div>
              <div className="dashboard-user-email">{user?.email || ''}</div>
            </>
          )}
        </div>
        <button className="dashboard-btn-logout" onClick={onLogout}>
          <span>🚪</span>
          {isOpen && <span>تسجيل الخروج</span>}
        </button>
      </div>
    </aside>
  );
};

export default DashboardSidebar;

